module.exports = __webpack_public_path__ + "static/img/profile-dummy.6d69652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profile-dummy.png
// module id = zgzu
// module chunks = 46